import { Col, Collapse, Row } from "antd";
import { isNull } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { setExpandSectionsAction } from "../../../../store/document/documentActions";
import { listRateClassesAction } from "../../../../store/rateClass/rateClassActions";
import { listTerritoriesAction } from "../../../../store/territory/territoryActions";
import { listVehicleTypesAction } from "../../../../store/vehicle/vehicleActions";
import DocumentSummary from "../DocumentSummary";
import PolicyCoverageAndPremiumsPanel from "./PolicyCoverageAndPremiumsPanel";
import PolicyCoverageTable from "./PolicyCoverageTable";
import PolicyCustomerPanel from "./PolicyCustomerPanel";
import PolicyDocumentPanel from "./PolicyDocumentPanel";
import PolicyPaymentPanel from "./PolicyPaymentPanel";
import PolicyVehiclePanel from "./PolicyVehiclePanel";

const PolicyTransactionView = ({ isNew }) => {
  const { control } = useFormContext();
  const dispatch = useDispatch();

  const [activeKeys, setActiveKeys] = useState(
    isNew ? ["1", "2", "3", "4", "5", "6"] : ["1", "2", "3"]
  );

  const vehicleTypes = useSelector((state) => state.vehicle.data);
  const rateClasses = useSelector((state) => state.rateClass.data);
  const territories = useSelector((state) => state.territory.data);
  const expandSections = useSelector(
    (state) => state.document.selectedUi.expandSections
  );

  useEffect(() => {
    if (isNull(vehicleTypes)) {
      dispatch(listVehicleTypesAction());
    }
  }, [vehicleTypes, dispatch]);

  useEffect(() => {
    if (isNull(rateClasses)) {
      dispatch(listRateClassesAction());
    }
  }, [rateClasses, dispatch]);

  useEffect(() => {
    if (isNull(territories)) {
      dispatch(listTerritoriesAction());
    }
  }, [territories, dispatch]);

  useEffect(() => {
    if (!isNull(expandSections)) {
      dispatch(setExpandSectionsAction(null));
      setActiveKeys(expandSections ? ["1", "2", "3", "4", "5", "6"] : []);
    }
  }, [expandSections, dispatch]);

  const onActiveKeyChangeHandler = (keys) => {
    setActiveKeys(Array.isArray(keys) ? keys : [keys]);
  };

  const items = useMemo(
    () => [
      {
        key: "1",
        label: "Summary",
        children: <DocumentSummary isNew={isNew} />,
      },
      {
        key: "2",
        label: "Document",
        children: <PolicyDocumentPanel control={control} isNew={isNew} />,
      },
      {
        key: "3",
        label: "Customer",
        children: <PolicyCustomerPanel isNew={isNew} control={control} />,
      },
      {
        key: "4",
        label: "Vehicle",
        children: <PolicyVehiclePanel control={control} />,
      },
      {
        key: "5",
        label: "Coverage & Premiums",
        children: (
          <Row>
            <Col span={12}>
              <PolicyCoverageTable control={control} />
            </Col>
            <Col span={12}>
              <PolicyCoverageAndPremiumsPanel control={control} />
            </Col>
          </Row>
        ),
      },
      {
        key: "6",
        label: "Payment",
        children: <PolicyPaymentPanel control={control} />,
      },
    ],
    [control, isNew]
  );

  return (
    <>
      <Row>
        <Col span={24}>
          <Collapse
            items={items}
            activeKey={activeKeys}
            onChange={onActiveKeyChangeHandler}
            size="small"
          />
        </Col>
      </Row>
    </>
  );
};

export default React.memo(PolicyTransactionView);
